import axios from 'axios'
import UserService from '@/services/userService'
import {apiToUser} from './converters'

const API_V1_URL = process.env.API_V1_URL
const userService = UserService(apiToUser)

function createUser(user) {
  return axios.post(API_V1_URL + '/users', user)
    .then(res => apiToUser(res.data))
}

function getUsersByRole(role, offset = 0, limit = 20) {
  var query = [
    ['role', role],
    ['offset', offset],
    ['limit', limit],
  ].map(pair => pair.join('=')).join('&')

  return axios.get(API_V1_URL + '/users?' + query)
    .then(res => {
      return {
        users: res.data.map(apiToUser),
        total: res.count,
      }
    })
}

export default {
  ...userService,
  getUser(id) {
    return axios.get(API_V1_URL + '/user/' + id)
      .then(res => apiToUser(res.data))
  },
  createUser(user) {
    user.role = 'admin'
    return createUser(user)
      .catch(errObj => errObj.error)
  },
  createClient(client) {
    client.role = 'client'
    return createUser(client)
  },
  getClients(offset, limit) {
    return getUsersByRole('client', offset, limit)
  },
  getUsers(offset, limit) {
    return getUsersByRole('admin', offset, limit)
  },
  updateClientGroups(id, cgroups) {
    return axios.patch(API_V1_URL + '/user/' + id, {cgroups})
      .then(res => res.data)
  },
  // AUTH
  sendMailForNewPass(email) {
    // It will trigger the server to send an email with a link for password reset
    return axios.post(API_V1_URL + '/credentials/lost', {email})
  },
}



// WEBPACK FOOTER //
// ./src/-service-app/services/userService.js